import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { BlockProps } from "@store/Components/Common/Block";
import { css } from "styled-components";

interface DetailContentProps {
    container?: GridContainerProps;
    gridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
}
interface DetailProps {
    block?: BlockProps;
    container?: GridContainerProps;
    imageGridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
    content?: DetailContentProps;
}
interface SpecificationsProps {
    specificationsContainer?: GridContainerProps;
    titleGridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
}
interface BottomContentProps {
    bottomContentContainer?: GridContainerProps;
    bottomContentGridItemFull?: GridItemProps;
    bottomContentGridItemLeft?: GridItemProps;
    bottomContentGridItemRight?: GridItemProps;
}
export interface StoreTearsheetProductDetailsViewStyles {
    detail?: DetailProps;
    specifications?: SpecificationsProps;
    bottomContent?: BottomContentProps;
}
export const storeTearsheetProductDetailsViewStyles: StoreTearsheetProductDetailsViewStyles = {
    detail: {
        container: {
            gap: 30,
            css: css`
                flex-direction: column;
                @media print {
                    ${GridOffset} {
                        display: flex;
                    }
                }
            `,
        },
        imageGridItem: {
            width: 6,
            css: css`
                flex-direction: column;
            `,
        },
        contentGridItem: { width: 6 },
        content: {
            container: { gap: 12 },
            gridItem: {
                width: 12,
                css: css`
                    display: flex;
                    flex-direction: column;
                `,
            },
            contentGridItem: {
                width: 12,
                css: css`
                    padding-top: 0;
                `,
            },
        },
    },
    specifications: {
        specificationsContainer: {
            gap: 10,
            css: css`
                margin-top: 10px;
                li[data-test-selector="brand_item"],
                li[data-test-selector="attributes_item"] {
                    padding: 0.5em 1.25em;
                    margin-top: -1px;
                    background-color: transparent;
                    border: 1px solid ${getColor("common.border")};
                    width: calc(50% - 5px) !important;
                }
            `,
        },
        titleGridItem: {
            width: 12,
            css: css`
                padding-bottom: 0;
            `,
        },
        contentGridItem: { width: 12 },
    },
    bottomContent: {
        bottomContentContainer: {
            gap: 10,
            css: css`
                margin-top: 30px;
                ${GridOffset} {
                    display: flex;
                    font-size: 10px;
                }
            `,
        },
        bottomContentGridItemFull: {
            width: 12,
        },
        bottomContentGridItemLeft: {
            width: 6,
        },
        bottomContentGridItemRight: {
            width: 6,
            css: css`
                text-align: right;
            `,
        },
    },
};
